// extracted by mini-css-extract-plugin
export default {"virtual":"Virtual_virtual__esxi9","left":"Virtual_left__frBl-","wrapper":"Virtual_wrapper__+XtSa"};